import { MONTH_CONSTANT } from "constants/MonthConstants";
import {
  HALF_YEAR_CONST,
  PERIODIC_CONST,
  PUBLICATIONS_PERIODIC_TYPES,
  QUARTER_YEAR_CONST,
} from "constants/PublicationConstants";

export const PeriodicTypeChecking = ({ periodicId, value, type }) => {
  if (periodicId === null || periodicId === undefined || periodicId === 0)
    return "";

  const getPeriodicType = PERIODIC_CONST[periodicId - 1];
  if (getPeriodicType?.type?.includes(type) && value) {
    if (type === PUBLICATIONS_PERIODIC_TYPES.MONTH) {
      const month = MONTH_CONSTANT[value - 1];
      return month.labelId;
    } else if (type === PUBLICATIONS_PERIODIC_TYPES.QUARTER) {
      if (periodicId === 4) {
        const getHalf = HALF_YEAR_CONST.find((att) => att.value === value);
        if (getHalf) {
          return getHalf.labelId;
        }
      } else {
        const getQuarter = QUARTER_YEAR_CONST.find(
          (att) => att.value === value
        );
        if (getQuarter) {
          return getQuarter.labelId;
        }
      }
    }
    return "";
  } else {
    return "";
  }
};
